import { lazy } from 'react'

import NewVenueLoader from './loader'

export default {
  NewVenue: {
    Component: lazy(() => import('./NewVenue.Page')),
    Loader: NewVenueLoader,
  },
}
